import { tokens } from "@blurb/codex-react";
import { Flex } from "@rpi/openapi-core";
import React from "react";
import { Body } from "../../../components/Typography";
import { getCountryLabel } from "../../../utils/country.util";
import { AccountSettingsCard } from "./AccountSettingsCard";
import { EMPTY_FIELD_PLACEHOLDER } from "./accountSettingsCopy";
import { FieldFrame } from "./FieldFrame";
import { FieldRow } from "./FieldRow";
import { LabeledField } from "./LabeledField";

interface OrganizationInformationCardProps {
  organizationName?: string | null;
  website?: string | null;
  size?: string | null;
  country?: string | null;
  canEdit: boolean;
  onEdit: () => void;
}

export const OrganizationInformationCard: React.FC<OrganizationInformationCardProps> = ({
  organizationName,
  website,
  size,
  country,
  canEdit,
  onEdit,
}) => {
  return (
    <AccountSettingsCard
      title="Organization Information"
      onEdit={canEdit ? onEdit : undefined}
      data-testid="organization-information-card"
    >
      <FieldFrame>
        <Flex.Column gap={2}>
          <Body size="lg" weight="bold" data-testid="organization-information-name">
            {organizationName || EMPTY_FIELD_PLACEHOLDER}
          </Body>
          <Flex sx={{ color: tokens.color.semantic.text.subtle }}>
            <Body data-testid="organization-information-website">{website || EMPTY_FIELD_PLACEHOLDER}</Body>
          </Flex>
        </Flex.Column>

        <FieldRow>
          <LabeledField label="Size" value={size || EMPTY_FIELD_PLACEHOLDER} testId="organization-information-size" />
          <LabeledField
            label="Country"
            value={getCountryLabel(country) || EMPTY_FIELD_PLACEHOLDER}
            testId="organization-information-country"
          />
        </FieldRow>
      </FieldFrame>
    </AccountSettingsCard>
  );
};
